import { FilterOptionDate, FilterOptionItem, Rank, Role } from './interfaces'
import tracker from '../../components/tracker/publish'

export const normalizeUserRoles = (roles: Array<Role>) => {
  return roles
    .filter((role: Role) => role.isMain === true)
    .map((role: Role) => ({
      id: role.id,
      name: role.label,
      value: role.id
    }))
}

export const normalizeUserRanks = (ranks: Array<Rank>) => {
  return ranks.map((rank: Rank) => ({
    id: rank.id,
    name: rank.name,
    value: rank.id
  }))
}

export const normalizeCategories = (categories: any[]) => {
  return categories
    .filter(parent => parent.categories)
    .map(parent => {
      return {
        parentId: parent.groupId,
        parentName: parent.groupName,
        items: parent.categories.map((child: { categoryName: any; categoryId: any }, idx: any) => {
          return {
            id: idx,
            name: child.categoryName,
            value: child.categoryId
          }
        })
      }
    })
}

export const fetchContentTypes = () => {
  const contentTypes = ['conversation', 'question', 'article']
  return contentTypes.map((contentType, idx) => ({
    id: idx,
    name: `${contentType.charAt(0).toUpperCase()}${contentType.slice(1)}`,
    value: contentType === 'conversation' ? 'discussion' : contentType
  }))
}

export const getDefaultDateRange = (presets: Array<FilterOptionDate>, defaultValue: string) => {
  return presets.filter((range: FilterOptionDate) => range.id === defaultValue)[0]
}

export function trackDashboardUsage (dashboardName: string) {
  tracker.trackEvent('userevent', {
    type: 'Dashboard viewed',
    new_dashboard: true,
    dashboard_name: dashboardName
  })
}

export function previousPeriodDifference (currentCount: number, previousCount: number) {
  if (previousCount === 0) {
    return 0
  }
  return ((currentCount - previousCount) / previousCount) * 100
}

export function getPlaceholderText (list: Array<FilterOptionItem>, selectedList: Array<string>) {
  const selectedListCount = selectedList.length

  if (selectedListCount === 0) {
    return 'All'
  }
  let placeholderText = list.find(({ value }: FilterOptionItem) => { return value.toString() === selectedList[0] })?.name
  if (selectedListCount - 1 === 0) {
    return placeholderText
  }
  return `${placeholderText} +${selectedList.length - 1}`
}

export function getCategoryPlaceholder (list: Array<FilterOptionItem>, selectedList: Array<string>) {
  const selectedListCount = selectedList.length
  if (selectedListCount === 0) {
    return {
      text: 'All',
      additionalText: ''
    }
  }
  let placeholderText = list.find(({ value }: FilterOptionItem) => { return value.toString() === selectedList[0] })?.name
  if (selectedListCount - 1 === 0) {
    return {
      text: placeholderText,
      additionalText: ''
    }
  }
  return {
    text: placeholderText,
    additionalText: `+${selectedList.length - 1}`
  }
}

export function getChildCategories (list: any[]) {
  let items: Array<FilterOptionItem> = []
  list.forEach(parent => {
    items.push(parent.items)
  })
  return items.flat()
}

export function createDefaultMetricItem () {
  return {
    count: 0,
    previousCount: 0,
    percentageDifference: 0
  }
}

export function getBrandBlue () {
  return '#0069FF'
}

export function getBrandGreen () {
  return '#24C25E'
}

export function getBrandPurple () {
  return '#B730A1'
}

export function getBrandBorderGrey () {
  return '#D5D6DA'
}

export function getBrandYellow () {
  return '#FFD000'
}

export function getDefaultSelectedDate () {
  return {
    id: 'custom_range',
    label: 'Custom range',
    startDate: new Date(),
    endDate: new Date()
  }
}
